import { useState } from 'react';
import { useRecordContext } from 'react-admin';
import { GrCertificate } from 'react-icons/gr';
import CardBasic from '../../../Components/UI/Show/CardBasic';
import TableMinimal from '../../../Components/UI/Show/TableMinimal';
import afipMerchant from '../Edit/AfipMerchant';
import { formatDecimal } from '../../../Utils/numbers';
import { CATEGORIAS } from '../constants';


const AfipCard = () => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);
  const categoria = CATEGORIAS.find((cat) => cat.id == record?.afip?.isib?.categoria)?.name
  
  const detailsArray = record && [
    {key: 'Cuit', value: record.afip?.cuit},
    {key: 'Provincia', value: record.afip?.domicilio?.provincia?.toUpperCase()},
    {key: 'Localidad', value: record.afip?.domicilio?.localidad?.toUpperCase()},
    {key: 'Calle', value: record.afip?.domicilio?.calle ? record.afip?.domicilio?.calle : '' + ' ' + record.afip?.domicilio?.altura ? record.afip?.domicilio?.altura : ''},
    {key: 'II BB', value: record.afip?.ii_bb},
    {key: 'Apto Lote', value: record.afip?.domicilio?.apto_lote},
    {key: 'Proceso de facturacion para planes', value: record?.afip?.activate_facturacion ? 'Habilitado' : 'Deshabilitado'},
    {key: 'Proceso de facturación para boletas en efectivo', value: record?.afip?.facturar_cash ? 'Habilitado' : 'Deshabilitado'},
    {key: 'Factura dividida', value: record?.afip?.tipo_facturación === 'dividida' ? 'Habilitado' : 'Deshabilitado'},
    {key: 'Habilita factura A', value: record?.afip?.acepta_factura_a ? 'Habilitado' : 'Deshabilitado'},
    {key: 'Leyenda de impuestos sobre ingresos brutos (ISIB)', value: record?.afip?.isib?.enabled ? 'Habilitado' : 'Deshabilitado'},
    {key: 'Categoría ISIB', value: categoria ?? 'No definida'},
    {key: 'Alicuota ISIB', value: record?.afip?.isib?.alicuota ? formatDecimal(record.afip.isib.alicuota) + ' %' : 'No definida'},
    {key: 'Convenio multilateral', value: record?.afip?.isib?.convenio_multilateral ? 'Habilitado' : 'Deshabilitado'},
    {key: 'Promoción económica', value: record?.afip?.isib?.promocion_economica ? 'Habilitado' : 'Deshabilitado'},
  ];
    
  const editComponent =  {
    component: afipMerchant(open),
    label: 'Datos de AFIP',
    icon: <GrCertificate/>
  };

  return (
    <CardBasic scrollable route={'merchants'} editComponent={editComponent} record={record} title='Facturación' open={open} setOpen={setOpen}>
      <TableMinimal data={detailsArray}/>
    </CardBasic>
  );
};

export default AfipCard;